export default __webpack_public_path__ + "static/media/recibo-assinatura.60578fbc.png";